// Model IDs offered as a free preview to non-subscribers, and those previewable
// across all member levels. Single source of truth shared by the model selector
// chips (ModelSelector) and the map source cards (via ForecastModelStore).
//
// Kept in a dependency-light module (no store imports) so the generic
// ModelSelector can read them without pulling in ForecastModelStore's map-store
// chain, which crashes on non-map pages where map globals aren't set up.
export const FREE_PREVIEW_MODELS = [279];
export const FREE_PREVIEW_ALL_MEMBER_LEVELS_MODELS = [280, 281];
